<div class="container">
  <mat-card>
    <form #dataTableFormRef [formGroup]="dataTableForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-row-wrap gap-2px responsive-column">
          <mat-form-field class="flex-40">
            <mat-label>{{ 'labels.inputs.Data Table Name' | translate }}</mat-label>
            <input matInput required formControlName="datatableName" />
            @if (dataTableForm.controls.datatableName.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Data Table Name' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="flex-fill flex-20">
            <mat-label>{{ 'labels.inputs.Entity Type' | translate }}</mat-label>
            <mat-select required formControlName="apptableName">
              @for (appTable of appTableData; track appTable) {
                <mat-option [value]="appTable.value">
                  {{ appTable.displayValue | translateKey: 'inputs' }}
                </mat-option>
              }
            </mat-select>
            @if (dataTableForm.controls.apptableName.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Application Table Name' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          @if (showEntitySubType) {
            <mat-form-field class="flex-fill flex-20">
              <mat-label>{{ 'labels.inputs.Entity SubType' | translate }}</mat-label>
              <mat-select formControlName="entitySubType">
                @for (entitySubType of entitySubTypeData; track entitySubType) {
                  <mat-option [value]="entitySubType.value">
                    {{ entitySubType.displayValue | translateKey: 'inputs' }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          @if (showSavingsSubType) {
            <mat-form-field class="flex-fill flex-20">
              <mat-label>{{ 'labels.inputs.Savings SubType' | translate }}</mat-label>
              <mat-select formControlName="entitySubType">
                @for (savingsSubType of savingsSubTypeData; track savingsSubType) {
                  <mat-option [value]="savingsSubType.value">
                    {{ savingsSubType.displayValue | translateKey: 'inputs' }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }

          <div class="multi-row-wrapper flex-14">
            <mat-checkbox labelPosition="before" formControlName="multiRow" class="multi-row">{{
              'labels.inputs.Multi Row' | translate
            }}</mat-checkbox>
          </div>
        </div>
        <br />

        <div class="layout-row-wrap gap-60percent layout-lt-md-column">
          <p class="mat-title flex-20">{{ 'labels.inputs.Columns' | translate }}</p>

          <button mat-raised-button class="flex-20" type="button" color="primary" (click)="addColumn()">
            <fa-icon icon="plus" class="m-r-10"></fa-icon>
            {{ 'labels.buttons.Add' | translate }} {{ 'labels.inputs.Columns' | translate }}
          </button>
        </div>

        <br />

        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Name' | translate }}</th>
            <td mat-cell *matCellDef="let column">
              {{ column.columnName }}
              @if (column.isColumnPrimaryKey) {
                <fa-icon
                  icon="check-circle"
                  size="lg"
                  class="column-mandatory"
                  matTooltip="{{ 'tooltips.Primary Key' | translate }}"
                  matTooltipPosition="right"
                ></fa-icon>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Type' | translate }}</th>
            <td mat-cell *matCellDef="let column">{{ column.columnDisplayType }}</td>
          </ng-container>

          <ng-container matColumnDef="length">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Length' | translate }}</th>
            <td mat-cell *matCellDef="let column">{{ column.columnLength }}</td>
          </ng-container>

          <ng-container matColumnDef="code">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Code' | translate }}</th>
            <td mat-cell *matCellDef="let column">{{ column.columnCode }}</td>
          </ng-container>

          <ng-container matColumnDef="mandatory">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.text.Mandatory' | translate }}</th>
            <td mat-cell *matCellDef="let column" class="left">
              @if (!column.isColumnNullable) {
                <fa-icon
                  icon="check-circle"
                  size="lg"
                  class="column-mandatory"
                  matTooltip="{{ 'tooltips.Yes' | translate }}"
                  matTooltipPosition="right"
                ></fa-icon>
              }
              @if (column.isColumnNullable) {
                <fa-icon
                  icon="times-circle"
                  size="lg"
                  class="not-column-mandatory"
                  matTooltip="{{ 'tooltips.No' | translate }}"
                  matTooltipPosition="right"
                ></fa-icon>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="unique">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="center">
              {{ 'labels.inputs.Unique' | translate }}
            </th>
            <td mat-cell *matCellDef="let column">
              @if (column.isColumnUnique) {
                <fa-icon
                  icon="check-circle"
                  size="lg"
                  class="column-mandatory"
                  matTooltip="{{ 'tooltips.Yes' | translate }}"
                  matTooltipPosition="right"
                ></fa-icon>
              }
              @if (!column.isColumnUnique) {
                <fa-icon
                  icon="times-circle"
                  size="lg"
                  class="not-column-mandatory"
                  matTooltip="{{ 'tooltips.No' | translate }}"
                  unique="right"
                ></fa-icon>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="indexed">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="center">
              {{ 'labels.inputs.Indexed' | translate }}
            </th>
            <td mat-cell *matCellDef="let column">
              @if (column.isColumnIndexed) {
                <fa-icon
                  icon="check-circle"
                  size="lg"
                  class="column-mandatory"
                  matTooltip="{{ 'tooltips.Yes' | translate }}"
                  matTooltipPosition="right"
                ></fa-icon>
              }
              @if (!column.isColumnIndexed) {
                <fa-icon
                  icon="times-circle"
                  size="lg"
                  class="not-column-mandatory"
                  matTooltip="{{ 'tooltips.No' | translate }}"
                  matTooltipPosition="right"
                ></fa-icon>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Actions' | translate }}</th>
            <td mat-cell *matCellDef="let column" class="gap-15percent">
              <button type="button" color="primary" mat-icon-button (click)="editColumn(column)">
                <fa-icon icon="edit" size="lg"></fa-icon>
              </button>
              <button type="button" color="warn" mat-icon-button (click)="deleteColumn(column)">
                <fa-icon icon="trash" size="lg"></fa-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button mat-raised-button color="primary" [disabled]="!dataTableForm.valid || columnData.length === 0">
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>

<ng-template #templateDataTableFormRef let-popover="popover">
  <h2>{{ 'labels.buttons.Create Datatable' | translate }}</h2>
  <p class="mw400">
    {{ 'labels.text.Filling Details' | translate }}
    <a href="https://LOSforge.jira.com/wiki/spaces/docs/pages/52592760/Manage+Data+Tables" target="_blank">{{
      'labels.inputs.Manage Datatables' | translate
    }}</a>
  </p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close()">
      {{ 'labels.buttons.Create Datatable' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStep()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStep()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>
